import {
  Material,
  Object3D,
  Texture,
  WebGLRenderer,
} from 'three';

const TEXTURE_KEYS = [
  'map',
  'alphaMap',
  'aoMap',
  'bumpMap',
  'displacementMap',
  'emissiveMap',
  'envMap',
  'lightMap',
  'metalnessMap',
  'normalMap',
  'roughnessMap',
  'clearcoatMap',
  'clearcoatNormalMap',
  'clearcoatRoughnessMap',
  'iridescenceMap',
  'iridescenceThicknessMap',
  'sheenColorMap',
  'sheenRoughnessMap',
  'specularColorMap',
  'specularIntensityMap',
  'transmissionMap',
  'thicknessMap',
] as const;

export const disposeMaterial = (material: Material | null | undefined) => {
  if (!material) return;

  const materialWithTextures = material as Material & Record<string, unknown>;
  for (const key of TEXTURE_KEYS) {
    const value = materialWithTextures[key];
    if (value instanceof Texture) value.dispose();
  }

  for (const value of Object.values(materialWithTextures)) {
    if (value instanceof Texture) value.dispose();
  }

  material.dispose();
};

export const disposeObject3D = (root: Object3D | null | undefined, removeFromParent = true) => {
  if (!root) return;

  root.traverse((object) => {
    const disposable = object as Object3D & {
      geometry?: { dispose: () => void };
      material?: Material | Material[];
      skeleton?: { dispose?: () => void };
    };

    disposable.geometry?.dispose();

    const materials = Array.isArray(disposable.material)
      ? disposable.material
      : disposable.material
        ? [disposable.material]
        : [];
    materials.forEach(disposeMaterial);
    disposable.skeleton?.dispose?.();
  });

  if (removeFromParent) root.parent?.remove(root);
  root.clear();
};

export const disposeRenderer = (renderer: WebGLRenderer | null | undefined) => {
  if (!renderer) return;
  renderer.renderLists.dispose();
  renderer.dispose();
  renderer.forceContextLoss();
  renderer.domElement.remove();
};
